import SlidingModal from '../home/mobile/SlidingModal';
import { Button } from '../ui/button';
import { FaHatCowboy } from 'react-icons/fa';
import FixedBtnWrapper from '../ui/FixBtnWrapper';
export default function WildModal({
  isModalOpen,
  toggleModal,
  setshowWildWest,
  setMode
}) {
  return <SlidingModal isOpen={isModalOpen} onClose={toggleModal} data-sentry-element="SlidingModal" data-sentry-component="WildModal" data-sentry-source-file="WildModal.tsx">
      <div className='ta-c justify-center pb-6 h-[500px]'>
        <div className='px-4'>
          <FaHatCowboy className='w-[60px] h-[60px] text-genius-cream mt-4' data-sentry-element="FaHatCowboy" data-sentry-source-file="WildModal.tsx" />

          <p className='text-red-400 text-[13px] mb-4'>Warning:</p>
          <p className='text-genius-gradient text-[18px]'>Entering the Wild West</p>
          <p className='text-genius-cream/50 text-[12px] my-10'>
            By clicking “I accept,” you will have access to all assets on the networks we support,
            including tokens not listed on verified sources. It is not encouraged for beginners or
            those unfamiliar with the risks and volatility of crypto to proceed.
            <br />
            <br />
            <span className='text-genius-cream '>Genius is not responsible for lost funds. </span>
          </p>
        </div>
        {isModalOpen && <FixedBtnWrapper className='bottom-[5px] absolute'>
            <Button onClick={() => {
          setMode('trending');
          setshowWildWest(true);
          toggleModal();
        }} className='bg-genius-pink md:hover:bg-genius-pink text-[16px] h-[56px] text-genius-blue w-full rounded-full mb-2'>
              I Accept the Risk
            </Button>
            <Button onClick={() => toggleModal()} className=' bg-genius-blue md:hover:bg-genius-blue text-[16px] h-[56px] text-genius-cream w-full rounded-full'>
              Back To Safety
            </Button>
          </FixedBtnWrapper>}
      </div>
    </SlidingModal>;
}